// extracted by mini-css-extract-plugin
module.exports = {"table":"_5f4b82e4e459dbd6703c25342cc9712b"};